import { render, staticRenderFns } from "./platformDistrictManagement.vue?vue&type=template&id=0c97ac68&scoped=true&"
import script from "./platformDistrictManagement.vue?vue&type=script&lang=js&"
export * from "./platformDistrictManagement.vue?vue&type=script&lang=js&"
import style0 from "./platformDistrictManagement.vue?vue&type=style&index=0&id=0c97ac68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c97ac68",
  null
  
)

export default component.exports